module.exports = __webpack_public_path__ + "static/media/Bluelab Probe Care Kit - pH.c7940fbe.webp";